import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'

import BoxSection from '../Layout/BoxSection'

import {
    updateInputs,
    addCotizacionAprobar,
    seleccionarCotizacionAprobar,
    recomendarCotizacion
} from '../../actions/solicitudbi'

import { downloadFile, getParameterByName } from '../../actions/common'
import { getPorcentaje, isAllowedToViewComponent, getDivisa, formatcoin } from '../../utils/helpers';

class Cotizaciones extends Component {


    getTotal = (valor, iva, cantidad) => {

        if (!valor) return 0
        if (!cantidad) return 0        

        const total = valor*cantidad
        return iva ? total+((iva*total)/100) : total
    }


    getProveedores = () => {

        const cotizaciones = this.props.solicitudBI.get('cotizaciones')
        const proveedores = []

        cotizaciones.map(c => {

            let index = -1

            proveedores.forEach((p,i) => {
                if (c.get('proveedor_id') == p.get('id')) index = i;                
            })

            if (c.get('proveedor_id') && index == -1) {
                proveedores.push(c.get('proveedore'))
            }
        })

        return proveedores.sort((a,b)=>(a.get('id')-b.get('id')))

    }




    getTipoCompra = (bien) => { 

        const tiene_proveedor = (bien.get('cotizaciones').filter(c => c.get('proveedor_id') != null).count() > 0)
        
        if (bien.get('compra_directa') && !tiene_proveedor) return 1
        if (!bien.get('compra_directa') && tiene_proveedor) return 2
        if (bien.get('compra_directa') && tiene_proveedor) return 3
        return 1
  
    }




    changeValueCotizacion = (cotizacion_id, attr, value) => {

        const bienes = this.props.solicitudBI.get('bienes')
        const cotizacion = this.props.solicitudBI.get('cotizaciones').filter(c => c.get('id') == cotizacion_id).first()
        const bien_id = cotizacion.getIn(['bienes', 0, 'id'])
        const bien_idx = bienes.findIndex(x => x.get('id') == bien_id)

        if (bien_idx >= 0) {


            if (attr == 'recomendado') {
                bienes.getIn([bien_idx, 'cotizaciones']).valueSeq().forEach(cot => {
                    const idx = bienes.getIn([bien_idx, 'cotizaciones']).findIndex(x => x.get('id') == cot.get('id'))
                    this.props.updateInputs(`solicitud.bienes.${bien_idx}.cotizaciones.${idx}.recomendado`, false)
                })
            }

            const cotizacion_idx = bienes.getIn([bien_idx, 'cotizaciones']).findIndex(x => x.get('id') == cotizacion_id)

            if (cotizacion_idx >= 0) {                
                this.props.updateInputs(`solicitud.bienes.${bien_idx}.cotizaciones.${cotizacion_idx}.${attr}`, value, cotizacion_id)
            }

        }

    } 



    getTotalSeleccionado = (proveedor_id) => {
        
        let total = 0


        this.props.solicitudBI.get('bienes').valueSeq().forEach(b => {
            const cantidad = b.get('cantidad_solicitada')
            b.get('cotizaciones').valueSeq().forEach(c => {
                if (c.get('recomendado') && c.get('proveedor_id') == proveedor_id) {
                    total += cantidad * Number(c.get('cotizado_iva'))
                }
            })
        })

        const cotizaciones_proveedor = this.props.solicitudBI.get('cotizaciones').filter(b => b.get('proveedor_id') == proveedor_id)
        const moneda = cotizaciones_proveedor ? cotizaciones_proveedor.first().get('moneda') : 'COP'
        const divisa = getDivisa(this.props.divisas, moneda)

        return formatcoin(total, divisa.simbolo)
    }

    
    getTotalCotizacion = () => {
        const total = this.props.solicitudBI.get('bienes').reduce((acum,bien) => {
            acum += bien.get('cotizaciones').filter(c => c.get('recomendado')).reduce((acum2, cotizacion)=> {
                const cotizado = Number(cotizacion.get('cotizado'))
                const iva = Number(cotizacion.get('iva'))
                const cotizado_iva = (cotizado + getPorcentaje(cotizado,iva))                
                const cantidad  = Number(bien.get('cantidad_solicitada'))
                acum2 += cotizado_iva * cantidad
                return acum2
            }, 0)
            return acum
        }, 0)
        return total 
    }


	render() {

        const { solicitudBI, divisas } = this.props

        const moneda = solicitudBI.get('cotizaciones') ? solicitudBI.get('cotizaciones').first().get('moneda') : 'COP'        
        const divisa = getDivisa(divisas, moneda)

        const proveedores = this.getProveedores()
       
        const es_responsable_compras = isAllowedToViewComponent('responsable_compras', solicitudBI)

        const readOnly = (solicitudBI.get('estado') == 0 || solicitudBI.get('estado') > 3 || solicitudBI.get('estado') == 8) || !es_responsable_compras

        return (
            <div>
                <div className="row">
                    <div className="col-md-12" style={{overflow: 'auto', whiteSpace: 'nowrap', paddingBottom: '25px'}}>
                        <table className="table table-condensed table-bordered table-striped" id="comparativo-cotizaciones">
                            <thead>
                                <tr>
                                    <td colSpan={4} style={{borderTop: '1px solid #FFF', borderLeft: '1px solid #FFF'}}></td>
                                    { 
                                        proveedores.map((p,i) => {
                                            return <th key={`phead[${i}]`}>{p.get('nombre')}</th>                                                        
                                        })
                                    }
                                    <th>COMPRA DIRECTA</th>
                                </tr>

                                <tr>
                                    <th>Descripción inicial</th>   
                                    <th style={{width:'230px'}}>Observación</th> 
                                    <th>U.M.</th> 
                                    <th>Cantidad</th>
                                    {
                                        proveedores.map((p,i) => {
                                            return <Fragment key={`pcol[${i}]`}>
                                                <th></th>
                                            </Fragment>                                                                                           
                                        })
                                    }
                                    <th></th>
                                </tr>



                            </thead> 
                            <tbody>
                            {
                                solicitudBI.get('bienes').map((bien, bienIndex) => {

                                    const cantidad = bien.get('cantidad_solicitada')

                                    const tipo_compra = this.getTipoCompra(bien)

                                    return <tr key={`itm[${bienIndex}]`}>

                                        <td>
                                            <input 
                                                className="form-control input-sm" 
                                                type="text" 
                                                style={{ width: '100%'}}
                                                value={bien.get('descripcion')||''} 
                                                onChange={ (e) => this.props.updateInputs(`solicitud.bienes.${bienIndex}.descripcion`, e.target.value, bien.get('id')) }  
                                                disabled={readOnly}
                                            />
                                        </td>

                                        <td>
                                            <textarea 
                                                className="form-control input-sm"
                                                width="100%"
                                                rows={5} 
                                                value = {bien.get('observaciones')||''}
                                                disabled={readOnly}
                                                onChange={ (e) => this.props.updateInputs(`solicitud.bienes.${bienIndex}.observaciones`, e.target.value, bien.get('id')) }
                                            />
                                        </td>
                                        
                                        <td>{bien.get('unidad')}</td>
                                        <td>{cantidad}</td>
                                        {
                                            proveedores.map(p => {

                                                const cotizaciones_proveedor = bien.get('cotizaciones').filter(cotizaciones => cotizaciones.getIn(['pivot', 'bienes_detalle_id']) == bien.get('id') && cotizaciones.get('proveedor_id') == p.get('id'))

                                                return(
                                                    <td key={`tdprov[${p.get('id')}][${bien.get('id')}]`}>
                                                        <table className="table table-condensed table-bordered table-striped">
                                                            <thead> 
                                                                <tr>
                                                                    <th></th>                                         
                                                                    <th>Marca</th>
                                                                    <th>Vlr. Unitario</th>
                                                                    <th>IVA</th>
                                                                    <th>Vlr. con IVA</th>
                                                                    <th>T. Entrega</th>
                                                                </tr>  
                                                            </thead>
                                                            <tbody>
                                                            {
                                                                cotizaciones_proveedor.map((cp, cpi) => {

                                                                    const moneda = cp.get('moneda') ? cp.get('moneda') : 'COP'
                                                                    const divisa = getDivisa(divisas, moneda)
                                                                    
                                                                    const valor = cp.get('cotizado')
                                                                    const iva = cp.get('iva')

                                                                    return <tr key={`cp[${bien.get('id')}][${cp.get('id')}][${cp.get('proveedor_id')}]`}>
                                                                        <td><input type="checkbox" checked={cp.get('recomendado')} onChange={(e) => this.changeValueCotizacion(cp.get('id'), 'recomendado', e.target.checked)} disabled={cp.get('estado') == 0 || cp.get('estado') == 2 || readOnly } /></td>
                                                                        <td><input type="text" className="form-control input-sm" value={ cp.get('marca') || '' } onChange={(e) => this.changeValueCotizacion(cp.get('id'), 'marca', e.target.value)} style={{ width: '150px'}} disabled={cp.get('estado') == 0 || cp.get('estado') == 2 || readOnly}/></td>
                                                                        <td><input type="number" className="form-control input-sm" value={ valor || '' } onChange={(e) => this.changeValueCotizacion(cp.get('id'), 'cotizado', e.target.value)} style={{ width: '150px'}} disabled={cp.get('estado') == 0 || cp.get('estado') == 2 || readOnly} /></td>
                                                                        <td><input type="number" className="form-control input-sm" value={ iva || ''  } onChange={(e) => this.changeValueCotizacion(cp.get('id'), 'iva', e.target.value)} style={{ width: '100px' }} disabled={cp.get('estado') == 0 || cp.get('estado') == 2 || readOnly} /></td>
                                                                        <td><div style={{ width: '150px', textAlign: 'right'}}>{ formatcoin( (this.getTotal(valor,iva,cantidad)), divisa.simbolo ) }</div></td>
                                                                        <td><input type="number" value={ cp.get('tiempo_entrega') || '' } onChange={(e) => this.changeValueCotizacion(cp.get('id'), 'tiempo_entrega', e.target.value)} className="form-control input-sm" style={{ width: '100px' }} disabled={cp.get('estado') == 0 || cp.get('estado') == 2 || readOnly} /></td>
                                                                    </tr>

                                                                })
                                                            }
                                                            </tbody>
                                                        </table>
                                                    </td>  
                                                )
                                            })
                                        }

                                        <td>

                                        {
                                            (tipo_compra == 1) && (
                                                <table className="table table-condensed table-bordered table-striped">
                                                    <thead> 
                                                        <tr>  
                                                            <th></th>  
                                                            <th>Proveedor</th>                                    
                                                            <th>Marca</th>
                                                            <th>Vlr. Unitario</th>
                                                            <th>IVA</th>
                                                            <th>Vlr. con IVA</th>
                                                            <th>T. Entrega</th>
                                                        </tr>  
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            bien.get('cotizaciones').map((cotizacion, cotizacionIndex) => {

                                                                const moneda = cotizacion.get('moneda') ? cotizacion.get('moneda') : 'COP'
                                                                const divisa = getDivisa(divisas, moneda)

                                                                const valor = cotizacion.get('cotizado') ? cotizacion.get('cotizado') : 0
                                                                const iva = cotizacion.get('iva') ? cotizacion.get('iva') : 0
                                                                return <tr key={`tr1[${bienIndex}][${cotizacionIndex}]`}>
                                                                    <td><input type="checkbox" checked={cotizacion.get('recomendado')} onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'recomendado', e.target.checked)} disabled={readOnly} /></td>
                                                                    <td><input type="text" className="form-control input-sm" value={cotizacion.get('proveedor_nombre_cp') || ''} onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'proveedor_nombre_cp', e.target.value)} style={{ width: '200px'}} disabled={readOnly} /></td>
                                                                    <td><input type="text" className="form-control input-sm" value={cotizacion.get('marca') || ''} onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'marca', e.target.value)} style={{ width: '150px'}} disabled={readOnly}/></td>
                                                                    <td><input type="number" className="form-control input-sm" value={ cotizacion.get('cotizado') || '' } onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'cotizado', e.target.value)} style={{ width: '150px'}} disabled={readOnly}/></td>                                                            
                                                                    <td><input type="number" className="form-control input-sm" value={ cotizacion.get('iva') } onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'iva', e.target.value)} style={{ width: '100px'}} disabled={readOnly}/></td>
                                                                    <td><div style={{ width: '150px', textAlign: 'right'}}>{ formatcoin( (this.getTotal(valor,iva,cantidad)), divisa.simbolo ) }</div></td>
                                                                    <td><input type="number" value={cotizacion.get('tiempo_entrega') || ''} onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'tiempo_entrega', e.target.value)} className="form-control input-sm" style={{ width: '100px'}} disabled={readOnly}/></td>
                                                                </tr>
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            )
                                        }


                                        {
                                            (tipo_compra == 3) && (
                                                <table className="table table-condensed table-bordered table-striped">
                                                    <thead> 
                                                        <tr> 
                                                            <th></th>   
                                                            <th>Proveedor</th>                                    
                                                            <th>Marca</th>
                                                            <th>Vlr. Unitario</th>
                                                            <th>IVA</th>
                                                            <th>Vlr. con IVA</th>
                                                            <th>T. Entrega</th>
                                                        </tr>  
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            bien.get('cotizaciones').filter(c => !c.get('proveedor_id')).map((cotizacion, cotizacionIndex) => {

                                                                const moneda = cotizacion.get('moneda') ? cotizacion.get('moneda') : 'COP'
                                                                const divisa = getDivisa(divisas, moneda)


                                                                const valor = cotizacion.get('cotizado') ? cotizacion.get('cotizado') : 0
                                                                const iva = cotizacion.get('iva') ? cotizacion.get('iva') : 0 

                                                                return <tr key={`tr1[${bienIndex}][${cotizacionIndex}]`}>
                                                                    <td><input type="checkbox" checked={cotizacion.get('recomendado')} onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'recomendado', e.target.checked)} disabled={readOnly} /></td>
                                                                    <td><input type="text" className="form-control input-sm" value={cotizacion.get('proveedor_nombre_cp') || ''} onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'proveedor_nombre_cp', e.target.value)} style={{ width: '200px'}} disabled={readOnly} /></td>
                                                                    <td><input type="text" className="form-control input-sm" value={cotizacion.get('marca') || ''} onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'marca', e.target.value)} style={{ width: '150px'}} disabled={readOnly}/></td>
                                                                    <td><input type="number" className="form-control input-sm" value={ cotizacion.get('cotizado') || '' } onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'cotizado', e.target.value)} style={{ width: '150px'}} disabled={readOnly}/></td>                                                            
                                                                    <td><input type="number" className="form-control input-sm" value={ cotizacion.get('iva') } onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'iva', e.target.value)} style={{ width: '100px'}} disabled={readOnly} /></td>
                                                                    <td><div style={{ width: '150px', textAlign: 'right'}}>{ formatcoin( (this.getTotal(valor,iva,cantidad)), divisa.simbolo ) }</div></td>
                                                                    <td><input type="number" value={cotizacion.get('tiempo_entrega') || ''} onChange={(e) => this.changeValueCotizacion(cotizacion.get('id'), 'tiempo_entrega', e.target.value)} className="form-control input-sm" style={{ width: '100px'}} disabled={readOnly}/></td>
                                                                </tr>
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            )
                                        }

                                        </td>

                                    </tr>
                                })
                            }

                                <tr style={{backgroundColor: '#eee'}}>
                                    <th colSpan={4} style={{ textAlign: 'right'}}><strong>Total Seleccionado por Proveedor</strong></th>
                                    {
                                        proveedores.map((p,i) => {
                                            return <Fragment key={`fcol[${i}]`}>
                                                <th><strong>{ this.getTotalSeleccionado(p.get('id')) }</strong></th>                                            
                                            </Fragment>
                                        })
                                    }
                                    <th></th>
                                </tr>

                            </tbody>             
                        </table>            
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <BoxSection title="Total presupuesto">
                            <div className="row" >
                                <div className="col-md-12 text-center" style={{fontSize: '18px', fontWeight: 'bold'}}>
                                    { formatcoin( this.getTotalCotizacion(), divisa.simbolo ) }                        
                                </div>
                            </div>
                        </BoxSection>
                    </div>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        solicitudBI: state.solicitudBI.get('solicitud'),
        divisas: state.common.getIn(['parametros', 'DIVISAS'])
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value, id) => dispatch(updateInputs(path, value, id)),
        addCotizacionAprobar: (path) => dispatch(addCotizacionAprobar(path)),
        seleccionarCotizacionAprobar: (cotizacion_id, bien_idx, cotizacion_aprobar_idx) => dispatch(seleccionarCotizacionAprobar(cotizacion_id, bien_idx, cotizacion_aprobar_idx)),
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)),
        recomendarCotizacion: (bien_id, proveedor_id) => dispatch(recomendarCotizacion(bien_id, proveedor_id))
        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cotizaciones)


// WEBPACK FOOTER //
// ./src/components/SolicitudBI/Cotizaciones.jsx